<template>
  <div>
    <component :is="currentComponent" @redirect:page="handlePageRedirection"></component>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import BaseLoaderModal from '../../../common/modal/BaseLoaderModal'
import Maintenance from '../Maintenance'
import ZeroBalance from '../ZeroBalance'
import {preGameMixin} from '../../../../common/mixins/game'
import modals from '../../../../common/modals'
import {preGameFailedReasonEnum} from '../../../../constants/game'

export default {
  name: 'pre-game-modal',
  emits: ['close:modal'],
  mixins: [
    preGameMixin
  ],
  data () {
    return {
      currentComponent: null
    }
  },
  created () {
    this.currentComponent = BaseLoaderModal

    modals.setupCommonModal({hideManually: true})

    this.checkRequirements()
  },
  methods: {
    closeModal ({canProceed = false} = {}) {
      this.$emit('close:modal', {canProceed})
    },
    checkRequirements () {
      const handleResponse = (data, gameType) => () => {

        if (data && data.canPlay) {
          // store gameType

          this.closeModal({canProceed: true})

          if (sessionStorage.getItem('toPage') !== '/game') {
            localStorage.setItem('isPreGameCompleted', true)
            this.$router.push('/game')
          }
        } else {
          if (!data || !Object.values(preGameFailedReasonEnum).includes(data.failedReason)) {
            this.closeModal()
          } else {
            if (data.failedReason === preGameFailedReasonEnum.ZERO_BALANCE) {
              this.currentComponent = ZeroBalance
            } else {
              this.currentComponent = Maintenance
            }

            const isCurrentPageIncludedInPreGameWhitelist = ['/home', '/home/store', '/home/notifications'].includes(sessionStorage.getItem('toPage'))

            modals.setupCommonModal({
              hideImmediate: !isCurrentPageIncludedInPreGameWhitelist,
              afterHideCallback: () => {
                this.closeModal()

                if (!isCurrentPageIncludedInPreGameWhitelist) {
                  this.$router.push('/home')
                }
              }
            })
          }
        }
      }

      const gameType = this.swipoGameThemes // 'NO_CATEGORY'

      this.$_canUserPlayTheGame(gameType).then(data => {
        modals.hideCommonModal({
          immediate: true,
          afterHideCallback: handleResponse(data, gameType)
        })
      })
    },
    handlePageRedirection ({pagePath}) {
      const isRedirectionNeeded = sessionStorage.getItem('toPage') !== pagePath

      modals.hideCommonModal({
        immediate: isRedirectionNeeded,
        afterHideCallback: () => {
          this.closeModal()

          if (isRedirectionNeeded) {
            this.$router.push(pagePath)
          }
        }
      })
    }
  },
  computed: {
    ...mapState('common', [
      'swipoGameThemes'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/pregame/PreGameModal.vue